<div class="modal-header">
  <app-summary-top class="w-100" [header]="header" [showSave]="false"></app-summary-top>
</div>

<div
  class="modal-body p-3 email-modal-body"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  @if (dragActive) {
    <div class="email-drop-overlay" i18n>Drop file to attach</div>
  }

  @if (fields) {
    <app-base-form #headerForm class="no-validation-ticks" [fields]="fields" [model]="reportTemplate()"></app-base-form>
  }

  <!-- ONE attachment strip: the document's own PDF, the files configured against the Document
       (tagged Always / with their country), and anything added for this send (removable).
       offset-sm-2 lines the strip and the Attach button up with the fields' controls, which
       sit in the 10 columns after their wideField labels. -->
  @if (stripItems().length) {
    <div class="row">
      <div class="email-attachment-strip offset-sm-2 col-sm-10">
        @for (chip of stripItems(); track chip.key) {
          <span
            class="email-file-chip"
            [class.email-file-chip-openable]="chip.openable"
            [title]="chip.name"
            (click)="openDocument(chip)"
            (keydown.enter)="openDocument(chip)"
            tabindex="0"
            role="button"
          >
            <span class="email-file-type email-file-type-{{ chip.extension }}">{{ chip.extension.toUpperCase() }}</span>
            <span class="email-file-name">{{ chip.name }}</span>
            @if (chip.sizeBytes) {
              <span class="email-file-size">{{ formatService.fileSize(chip.sizeBytes) }}</span>
            }
            @if (chip.tag) {
              <span class="email-file-tag">{{ chip.tag }}</span>
            }
            @if (chip.removable) {
              <button
                type="button"
                class="email-file-remove"
                i18n-aria-label
                aria-label="Remove attachment"
                (click)="removeDocument(chip); $event.stopPropagation()"
              >
                &times;
              </button>
            }
          </span>
        }
      </div>
    </div>
  }

  <div class="row mb-3">
    <div class="offset-sm-2 col-sm-10">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fileInput.click()">
        <i class="fa fa-paperclip me-1"></i>{{ attachFileText }}
      </button>
      <input #fileInput type="file" multiple class="d-none" (change)="onFileChosen($event)" />
    </div>
  </div>

  @if (bodyFields) {
    <app-base-form #bodyForm [fields]="bodyFields" [model]="reportTemplate()"></app-base-form>
  }
</div>

<div class="modal-footer">
  <span class="me-auto text-muted">{{ attachmentSummary() }}</span>
  <button type="button" class="btn btn-secondary" (click)="onCancel()" i18n>Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="sendDisabled()" (click)="onSend()">
    <i class="fa fa-envelope me-1"></i><ng-container i18n>Send</ng-container>
  </button>
</div>
